import React from 'react'

import classes from './SubmitSuccess.module.scss'
import classNames from 'classnames/bind'

type Props = {
  isDark?: boolean
  isSmall?: boolean
  customClasses?: string
  onSvgAnimationEnd?: () => void
}

const cx = classNames.bind(classes)

export const SubmitSuccess = ({
  isDark,
  isSmall,
  customClasses = '',
  onSvgAnimationEnd,
}: Props): JSX.Element => {
  const replyClasses = cx('reply', {
    dark: isDark,
    small: isSmall,
    [customClasses]: !!customClasses,
  })

  return (
    <div className={replyClasses}>
      <div className={classes.col__loader}>
        <svg
          width="188"
          height="188"
          viewBox="0 0 188 188"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={classes.loader}
          onAnimationEnd={() => onSvgAnimationEnd && onSvgAnimationEnd()}
        >
          <g transform="rotate(-90 94 94)">
            <circle cx="94" cy="94" r="92" strokeWidth="2" />
          </g>
          <path
            transform="translate(70,70)"
            d="M20 45.5L0 19L2.5 17L20 30.5L52 0L54.5 2L20 45.5Z"
          />
        </svg>
      </div>
      <div className={classes.col__info}>
        <span className={`${classes.reply__title} uppercase`}>Спасибо!</span>
        {!isSmall && (
          <p className={classes.reply__text}>
            Ваша заявка будет рассмотрена <br /> в ближайшее время
          </p>
        )}
      </div>
    </div>
  )
}
